import { SHOW_ALERT, SHOW_ALERT_INIT } from "./actionTypes";
import { LOGOUT_USER_SUCCESS } from "../actionTypes";

const initialState = {
  showAlert: false,
  alertMessage: "",
};

const config = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_ALERT:
      return {
        ...state,
        showAlert: true,
        alertMessage: action.message,
      };
    case SHOW_ALERT_INIT:
      return {
        ...state,
        showAlert: false,
        alertMessage: null,
      };
    case LOGOUT_USER_SUCCESS:
      return {
        ...state,
        showAlert: false,
        alertMessage: null,
      };
    default:
      return state;
  }
};

export default config;
